export default function Skills() {
  return (
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h2 class="display-5">Skills</h2>
            <hr class="my-4" />
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Level</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">Java</th>
                  <td>4/5</td>
                </tr>
                <tr>
                  <th scope="row">SQL</th>
                  <td>3.5/5</td>
                </tr>
                <tr>
                  <th scope="row">Android</th>
                  <td>3/5</td>
                </tr>
                <tr>
                  <th scope="row">HTML5</th>
                  <td>4/5</td>
                </tr>
                <tr>
                  <th scope="row">CSS3</th>
                  <td>4/5</td>
                </tr>
                <tr>
                  <th scope="row">Git</th>
                  <td>3/5</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6">
            <h2 class="display-5">Education</h2>
            <hr class="my-4" />
            <div class="card no-border-shadow">
              <div class="card-body">
                <h5 class="card-title">L.D. College of Engineering</h5>
                <h6 class="card-subtitle mb-2 text-muted">Ahmedabad, India</h6>
                <p class="card-text">B.E in Computer Engineering</p>
              </div>
            </div>
            <div class="card no-border-shadow">
              <div class="card-body">
                <h5 class="card-title">Nirma University</h5>
                <h6 class="card-subtitle mb-2 text-muted">Ahmedabad, India</h6>
                <p class="card-text">Diploma in Computer Engineering</p>
              </div>
            </div>
            <div class="card no-border-shadow">
              <div class="card-body">
                <h5 class="card-title">A-one School</h5>
                <h6 class="card-subtitle mb-2 text-muted">Ahmedabad, India</h6>
                <p class="card-text">Primary &amp; Secondary education</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
